module.exports = __webpack_public_path__ + "img/antaira-logo-slogan.21e91d23.png";